import React, {useContext, useState} from 'react'
import { makeStyles, withStyles} from 'external/material'
import Box from '@mui/material/Box'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {faEye} from "@fortawesome/free-solid-svg-icons"
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'

import PreviewQuestion from 'components/quiz/components/preview-question'
import {TeacherContext} from 'teacher/context'
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const styles = (theme) => ({
  root: {
    zIndex: '2000 !important'
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500]
  }
});

const useStyles = makeStyles(styles)

export default function PreviewQuestionTooltip (props) {

  const context = useContext(TeacherContext)
  const classes = useStyles()
  const [open, setOpen] = useState(false)

  const {translate} = context

  const handleClose = () =>{ 
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true); 
  };

  return (
    <div>
      <Box onClick={handleOpen} className={classes.link}> <FontAwesomeIcon className="icon" icon={faEye} /></Box>
      <Dialog
        fullWidth={true}
        maxWidth={'md'}
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        className={classes.root}
        >
        <DialogTitle id={classes.title}>
          {translate('preview')}
            <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
            <PreviewQuestion headless showPoints showStandards context={context} question={props} />
        </DialogContent>
      </Dialog>
    </div>
  )
};
